export default __webpack_public_path__ + "static/media/6.db6680a9.jpg";